module.exports = __webpack_public_path__ + "img/img16.34f045e5.png";